// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const optArrItem = (condition: boolean, item: any) => {
  return condition ? [item] : [];
};
